<template>
    <BreadCrumb PageTitle="Modifier une étagère" />
    <EditEtagere />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditEtagere from "../../components/Etagere/EditEtagere.vue";
  
    export default defineComponent({
      name: "EditEtagerePage",
      components: {
        BreadCrumb,
        EditEtagere,
      },
    });
  </script>